module.exports = __webpack_public_path__ + "img/china-southern.66227466.jpg";